module.exports = __webpack_public_path__ + "static/media/6.ee6c5deb.svg";